import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

type PaymentProvider = 'stripe' | 'paypal' | 'square';

export const fetchStudioDefaultPaymentProviderAPI = async () => {
  const response = await baseAPI.get<{
    paymentProvider: PaymentProvider;
  }>(`/studios/default-payment-provider`);
  return response.data;
};

export const useGetStudioDefaultPaymentProvider = () => {
  return useQuery({
    queryKey: [KEYS.STUDIO_DEFAULT_PAYMENT_PROVIDER],
    queryFn: () => fetchStudioDefaultPaymentProviderAPI(),
  });
};
